export const BLOG_SEO = {
  title: 'Latest update on Internet and Technology - Exetel',
  description:
    'Read the latest updates on broadband technology, internet network and mobile technology.',
  seo_keywords: '',
};
